import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { priceBlockStyles } from './PriceBlock.styles';

export type PriceBlockSize = keyof typeof priceBlockStyles.size;

export type PriceBlockProps = HTMLAttributes<HTMLDivElement> & {
  amount: string;
  secondary?: ReactNode;
  size?: PriceBlockSize;
};

export function PriceBlock({
  className,
  amount,
  secondary,
  size = 'md',
  ...props
}: PriceBlockProps): JSX.Element {
  return (
    <div className={cn(priceBlockStyles.root, priceBlockStyles.size[size], className)} {...props}>
      <span>{amount}</span>
      {secondary ? <span className={priceBlockStyles.secondary}>{secondary}</span> : null}
    </div>
  );
}
